import { Box, Theme, Typography, useTheme } from "@mui/material";
import DifferenceChip from "src/components/Difference/DifferenceChip";

type MetricLeftBlockVariant = "footfall" | "weather";
interface MetricLeftBlockProps {
  variant: MetricLeftBlockVariant;
  diff: number | null;
  totalCurrentValue?: string | number;
  totalPastValue?: string | number;
  pastLabel?: string;
  totalCount?: string | number;
  avgTemp?: string | number;
  tempLabel?: string;
}

const getStyles = (theme: Theme) => ({
  pastValue: { fontSize: theme.fontSizes.display, fontWeight: theme.typography.fontWeightRegular },
  pastValueText: { fontSize: theme.fontSizes.md, fontWeight: theme.typography.fontWeightLight },
});

export default function MetricLeftBlock({
  variant,
  diff,
  totalCurrentValue,
  totalPastValue,
  pastLabel,
  totalCount,
  avgTemp,
  tempLabel,
}: MetricLeftBlockProps) {
  const theme = useTheme();

  if (variant === "weather") {
    return (
      <Box display='flex' alignItems='center' gap={1}>
        <Typography variant='h2'>{totalCount}</Typography>

        <DifferenceChip difference={diff} fontSize={theme.fontSizes.md} />

        <Box display='flex' alignItems='center' gap={1}>
          <Box color={theme.palette.text.secondary} fontSize={theme.fontSizes.display}>
            {`${avgTemp}°C`}
          </Box>

          <Box color={theme.palette.text.secondary} fontSize={theme.fontSizes.sm}>
            {tempLabel}
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box display='flex' alignItems='center' gap={1}>
      <Typography variant='h2'>{totalCurrentValue}</Typography>

      <DifferenceChip difference={diff} fontSize={theme.fontSizes.md} />

      <Box display='flex' alignItems='center' gap={1}>
        <Typography sx={getStyles?.(theme).pastValue} color={theme.palette.text.secondary}>
          {totalPastValue}
        </Typography>

        <Typography sx={getStyles?.(theme).pastValueText} color={theme.palette.text.secondary}>
          {pastLabel}
        </Typography>
      </Box>
    </Box>
  );
}
